export default "__VITE_ASSET__XjisqtNRVme6srN496NpNg__"